var examPrices = {
  tradeTestExamFeePerCandidate: "₦5,000",
  casExamFeePerCandidate: "₦5,000",
  publicServiceExamTradeTest: "₦5,000",
  beceExamFeePerCandidate: "₦6,000",
  casLateRegistrationFee: "₦7,500",
  beceLateRegistrationFee: "₦8,500",
  modelCollegeExamFeePerCandidiate: "₦10,000",
  publicServiceExamCompulsory: "₦10,000",
  publicServiceExamCombined: "₦10,000",
  publicServiceLateRegExamTradeTest: "₦10,000",
  publicServiceExamSecretarial: "₦10,000",
  publicServiceExamAllCadres: "₦10,000",
  publicServiceExamCombinedConfirmation: "₦10,000",
  publicServiceLateRegExamCompulsory: "₦15,000",
  modelCollegeLateRegistration: "₦15,000",
  publicServiceLateRegExamCombined: "₦15,000",
  publicServiceLateRegExamSecretarial: "₦15,000",
  beceRetakeExamFeePerCandidate: "₦3,000",

};

export { examPrices };
